import { SVGProps } from 'react'

const SvgDownloadCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 96 960 960' {...props}>
    <path d='M320 776h320q17 0 28.5-11.5T680 736q0-17-11.5-28.5T640 696H320q-17 0-28.5 11.5T280 736q0 17 11.5 28.5T320 776Zm120-274-36-35q-11-11-27.5-11T348 468q-11 11-11 28t11 28l104 104q12 12 28 12t28-12l104-104q11-11 11.5-27.5T612 468q-11-11-27.5-11.5T556 467l-36 35V376q0-17-11.5-28.5T480 336q-17 0-28.5 11.5T440 376v126Zm40 474q-83 0-156-31.5T197 859q-54-54-85.5-127T80 576q0-83 31.5-156T197 293q54-54 127-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 83-31.5 156T763 859q-54 54-127 85.5T480 976Z' />
  </svg>
)

export default SvgDownloadCircle
